import { Grid } from '@orbita-ui/core';
import {
  LoginFooterBottom,
  LoginFooterContainer,
  LoginFooterTop,
} from './LoginFooter.styles';

export const LoginFooter = () => (
  <LoginFooterContainer>
    <LoginFooterTop>
      <Grid>
        <Grid.Item sm={6} xs={4}>
          <p>PRISMA MEDIOS DE PAGO S.A.</p>
        </Grid.Item>
        <Grid.Item sm={6} xs={4}>
          <p>Defensa al Consumidor | Protección de datos personales</p>
        </Grid.Item>
      </Grid>
    </LoginFooterTop>
    <LoginFooterBottom>
      <p>
        Los datos que se proporcionen a Prisma Medios de Pago S.A. podrán utilizarse para
        procesar sus pedidos, solicitudes, denuncias, reclamos, para la relación comercial
        y fines publicitarios. Disposición DNPDP 10/2008: "El titular de los datos
        personales tiene la facultad de ejercer el derecho de acceso a los mismos en forma
        gratuita a intervalos no inferiores a seis meses, salvo que se acredite un interés
        legítimo al efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley
        Nº 25.326" y "La DIRECCION NACIONAL DE PROTECCION DE DATOS PERSONALES, Organo de
        Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y
        reclamos que se interpongan con relación al incumplimiento de las normas sobre
        protección de datos personales."
      </p>
    </LoginFooterBottom>
  </LoginFooterContainer>
);
